
/**
 * lang.js
 */

// 配置网站支持的语言
const langs = {
  en: 'en',
  'zh-cn': 'zh-CN'
}

// en cn 66 63
const languages = {
  en: 'en',
  'zh-CN': 'cn'
}
const tids = {
  en: '66',
  'zh-CN': '63'
}

function httpPost(url, params = "") {
  let httpRequest = new XMLHttpRequest();
  httpRequest.open("POST", url, true);
  httpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  httpRequest.send(params);
  httpRequest.onreadystatechange = () => {
    if (httpRequest.readyState === 4 && httpRequest.status === 200) {
      return JSON.parse(httpRequest.responseText);
    }
  }
}


let screen_width = window.screen.width
let screen_height = window.screen.height
let path = window.location.pathname
let referrer = document.referrer


export const statistics = (screen_width,screen_height) => {
    httpPost("/", "screen_width=" + screen_width
        + "&screen_height=" + screen_height
        + "&path=" + path
        + "&referrer=" + referrer
    )
}



const getLanguage = lang => {
  return languages[lang] || 'en'
}

/**
 * 获取浏览器的语言设置
 * 如果没找到则返回一个默认值 en
 */
export const getLang = () => {
  let lowerLang = (window.navigator.language ||
    window.navigator.browserLanguage ||
    'en').toLowerCase()

  // default: en
  return langs[lowerLang] || 'en'
}

/**
 * 设置 html 标签的 lang
 */
export const setHtmlLang = lang => {
  // documentElement 根root HTML
  document.documentElement.setAttribute('lang', lang)
}

export const getHomeswiperUrl = lang => {
  const language = getLanguage(lang)
  return `/php/pic.php?type=%E9%A6%96%E9%A1%B5banner&num=4&language=${language}`
}

export const getHomeswiperUrl2 = lang => {
  const language = getLanguage(lang)
  return `/php/pic.php?type=%E6%89%8B%E6%9C%BA%E9%A6%96%E9%A1%B5banner&num=4&language=${language}`
}

export const getProductstypeUrl = lang => {
  const language = getLanguage(lang)
  const tid = tids[lang] || '66'
  return `/php/productstype.php?language=${language}&tid=${tid}&num=100`
}

export const getProductstypeUrl2 = (lang,tid) => {
  const language = getLanguage(lang)
  return `/php/productstype.php?language=${language}&tid=${tid}&num=100`
}

export const getProductsUrl = (lang, tid, page) => {
  const language = getLanguage(lang)
  return `/php/products.php?language=${language}&tid=${tid}&num=12&page=${page}`
}

export const getNewsUrl = (lang, tid, page) => {
  const language = getLanguage(lang)
  return `/php/news.php?language=${language}&newstype=${tid}&num=9&page=${page}`
}

export const getCommonUrl = (lang, tid) => {
  const language = getLanguage(lang)
  return `/php/products.php?language=${language}&tid=${tid}&num=100`
}

export const getPicUrl = (lang, type, num) => {
  const language = getLanguage(lang)
  return `/php/pic.php?type=${type}&num=${num}&language=${language}`
}

export const getJobUrl = (lang) => {
  const language = getLanguage(lang)
  return `/php/job.php?language=${language}`
}

export const column_info = (cid) => {
  return `https://www.funjoycn.com/api/column_info?cid=${cid}`
}
export const get_column = (lang) => {
  return `https://www.funjoycn.com/api/get_column`
}

export const pro_type = (lang) => {
  return `https://www.funjoycn.com/api/pro_type`
}

export const get_pro_list = (cid,page) => {
  return `https://www.funjoycn.com/api/get_pro_list?cid=${cid}&page=${page}`
}
export const get_pro = (id) => {
  return `https://www.funjoycn.com/api/get_pro?id=${id}`
}
export const message = (email) => {
  return `/api/message?form_id=1&email=${email}`
}
